export const PUBLIC_SCHOOL_PROFILE_STORAGE_KEY = 'publicSchoolProfile';

export const buildPublicSchoolProfile = (school = {}) => ({
  schoolId: school.schoolId != null ? String(school.schoolId) : '',
  name: school.name || '',
  logoUrl: school.logoUrl || '',
  slogan: school.slogan || '',
  phone: school.phone || '',
  email: school.email || '',
  address: school.address || '',
  websiteUrl: school.websiteUrl || '',
  principalName: school.principalName || '',
  description: school.description || '',
  openingHours: school.openingHours || '',
  recognisedBy: school.recognisedBy || '',
  affiliationBoard: school.affiliationBoard || '',
  subDomain: school.subDomain || '',
  customDomain: school.customDomain || '',
  latitude:
    school.latitude !== null && school.latitude !== undefined && school.latitude !== ''
      ? String(school.latitude)
      : '',
  longitude:
    school.longitude !== null && school.longitude !== undefined && school.longitude !== ''
      ? String(school.longitude)
      : '',
  facebookLink: school.facebookLink || '',
  instagramLink: school.instagramLink || '',
  twitterLink: school.twitterLink || '',
});

export const getStoredPublicSchoolProfile = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const raw = localStorage.getItem(PUBLIC_SCHOOL_PROFILE_STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (_error) {
    return {};
  }
};

export const getPublicMapEmbedUrl = (profile = {}) => {
  const latitude = String(profile.latitude || '').trim();
  const longitude = String(profile.longitude || '').trim();
  if (latitude && longitude) {
    return `https://www.google.com/maps?q=${encodeURIComponent(`${latitude},${longitude}`)}&z=15&output=embed`;
  }

  const address = String(profile.address || '').trim();
  if (address) {
    return `https://www.google.com/maps?q=${encodeURIComponent(address)}&z=15&output=embed`;
  }

  return '';
};
